<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="90px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName"
                               labelValue="id" title="选择用户" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="客服名称">
                  <el-input style="width: 177px;" v-model="queryForm.customerName"></el-input>
              </el-form-item>
              <el-form-item label="公司名称">
                  <el-input style="width: 177px;" v-model="queryForm.companyName"></el-input>
              </el-form-item>
              <el-form-item label="是否多坐席">
<!--                  <el-input style="width: 177px;" v-model="queryForm.multipleSeat"></el-input>-->
                  <el-select
                      size="small"
                      style="width: 177px;"
                      v-model="queryForm.multipleSeat"
                  >
                      <el-option
                          label="是"
                          :value="1"
                      ></el-option>
                      <el-option
                          label="否"
                          :value="0"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="托管给系统">
<!--                  <el-input style="width: 177px;" v-model="queryForm.aiCustomer"></el-input>-->
                  <el-select
                      size="small"
                      style="width: 177px;"
                      v-model="queryForm.aiCustomer"
                  >
                      <el-option
                          label="是"
                          :value="1"
                      ></el-option>
                      <el-option
                          label="否"
                          :value="0"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getImWebimCustomerList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addImWebimCustomer"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editImWebimCustomer(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteImWebimCustomer(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshImWebimCustomerList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="imWebimCustomerList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="customerName"
        label="客服名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="customerHeader"
        label="客服头像"
        width="180"
      > 
        <template slot-scope="scope">
          <div v-if='scope.row.customerHeader'>
            <el-image @click='updateSrcList(scope.row.customerHeader)' style="width: 60px; height: 60px"
              :src="scope.row.customerHeader" :preview-src-list="srcList"> </el-image>
          </div>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="greeting"
        label="问候语"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="companyName"
        label="公司名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="companyDescription"
        label="公司简介"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="multipleSeat"
        label="是否多坐席"
        width="180"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.multipleSeat == 1">是</span>
          <span v-else>否</span>
        </template> 
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="aiCustomer"
        label="托管给系统"
        width="180"
      > 
      <template slot-scope="scope">
          <span v-if="scope.row.aiCustomer == 1">是</span>
          <span v-else>否</span>
        </template> 
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label=""
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkImWebimCustomer(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editImWebimCustomer(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteImWebimCustomer(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="imWebimCustomerStates[imWebimCustomerState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="imWebimCustomer"
          ref="imWebimCustomerForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户"
            prop="userId"
          >
            <!-- <el-input
              size="small"
              v-model="imWebimCustomer.userId"
              :disabled="imWebimCustomerState == 'check'"
            ></el-input> -->
            <GridSelectU style="width: 177px;" labelName="userName" :disabled="imWebimCustomerState == 'check'"
                labelValue="id" title="选择用户" :value="imWebimCustomer.userId" :limit='1' size='small' placeholder='请选择用户'
                @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="客服名称"
            prop="customerName"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="imWebimCustomer.customerName"
              :disabled="imWebimCustomerState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="问候语"
            prop="greeting"
          >
            <el-input
              size="small" style="width: 177px;"
              v-model="imWebimCustomer.greeting"
              :disabled="imWebimCustomerState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="公司名称"
            prop="companyName"
          >
            <el-input
              size="small" style="width: 177px;"
              v-model="imWebimCustomer.companyName"
              :disabled="imWebimCustomerState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="是否多坐席"
            prop="multipleSeat"
          >
            <!-- <el-input
              size="small"
              v-model="imWebimCustomer.multipleSeat"
              :disabled="imWebimCustomerState == 'check'"
            ></el-input> -->
            <el-select
              size="small"
              style="width: 177px;"
              v-model="imWebimCustomer.multipleSeat"
              :disabled="imWebimCustomerState == 'check'"
            >
              <el-option
                label="是"
                :value="1"
              ></el-option>
              <el-option
                label="否"
                :value="0"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="托管给系统"
            prop="aiCustomer"
          >
            <!-- <el-input
              size="small"
              v-model="imWebimCustomer.aiCustomer"
              :disabled="imWebimCustomerState == 'check'"
            ></el-input> -->
            <el-select
              size="small"
              style="width: 177px;"
              v-model="imWebimCustomer.aiCustomer"
              :disabled="imWebimCustomerState == 'check'"
            >
              <el-option
                label="是"
                :value="1"
              ></el-option>
              <el-option
                label="否"
                :value="0"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="公司简介"
            prop="companyDescription"
          >
            <el-input
              size="small"
              type="textarea"
              :rows="8"
              style="width: 177px;"
              v-model="imWebimCustomer.companyDescription"
              :disabled="imWebimCustomerState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="客服头像"
            prop="customerHeader"
          >
            <!-- <el-input
              size="small"
              style="width: 177px;"
              v-model="imWebimCustomer.customerHeader"
              :disabled="imWebimCustomerState == 'check'"
            ></el-input> -->
            <el-upload
                :disabled="imWebimCustomerState == 'check'"
                style="width: 177px"
                class="avatar-uploader"
                action=""
                :show-file-list="false"
                :http-request="uploadAvatar">
                <img v-if="imWebimCustomer.customerHeader" :src="imWebimCustomer.customerHeader" class="avatar" size="small" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="imWebimCustomerState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_PATH, UPLOAD_API, USER, PRODUCT, PRODUCT_SEARCH, USER_SEARCH } from '@/utils/constant.js';
import GridSelectU from '@/components/gridselect';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetImWebimCustomerList();
                    this.getImWebimCustomerList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetImWebimCustomerList();
                    this.getImWebimCustomerList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                USER_code: USER,
                USER_search: USER_SEARCH,
                queryForm:{
                     userId: '', //用户
                     customerName: '', //客服名称
                     customerHeader: '', //客服头像
                     greeting: '', //问候语
                     companyName: '', //公司名称
                     companyDescription: '', //公司简介
                     multipleSeat: '', //默认单坐席0  可选多坐席1
                     aiCustomer: '', //0 人工客服 1 智能客服
                     createTime: '', //
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                imWebimCustomerState: 'add',
                imWebimCustomerStates: {
                    add: '新建客服',
                    check: '查看客服',
                    edit: '修改客服'
                },

                multipleSelection: [],
                imWebimCustomerList: [],
                imWebimCustomer: {
                    id: '', //ID
                    userId: '', //用户
                    customerName: '', //客服名称
                    customerHeader: '', //客服头像
                    greeting: '', //问候语
                    companyName: '', //公司名称
                    companyDescription: '', //公司简介
                    multipleSeat: 0, //默认单坐席0  可选多坐席1
                    aiCustomer: 0, //0 人工客服 1 智能客服
                    createTime: '', //
                },
                btnLoading: false,
                srcList:[''],
                rules: {
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    customerName: [{ required: true, message: '客服名称不能为空', trigger: 'blur' }],
                    customerHeader: [{ required: true, message: '客服头像不能为空', trigger: 'blur' }],
                    greeting: [{ required: true, message: '问候语不能为空', trigger: 'blur' }],
                    companyName: [{ required: true, message: '公司名称不能为空', trigger: 'blur' }],
                    companyDescription: [{ required: true, message: '公司简介不能为空', trigger: 'blur' }],
                    multipleSeat: [{ required: true, message: '默认单坐席0  可选多坐席1不能为空', trigger: 'blur' }],
                    aiCustomer: [{ required: true, message: '0 人工客服 1 智能客服不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getImWebimCustomerList();
        },
        methods: {
            //上传缩略图
            uploadAvatar(params) {
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
                if (!types.includes(file.type)) {
                    this.$message.error('图片类型错误!');
                }
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                upload(UPLOAD_PATH, formData).then((res) => {
                    if (res.success) {
                        this.imWebimCustomer.customerHeader = res.url;
                    }
                });
            },
            // 大图预览
            updateSrcList(src) {
              this.srcList[0] = src
            },
            getValueUser(value) {
              this.imWebimCustomer.userId = value
            },
            getSearchValueUser(value) {
                this.queryForm.userId = value
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            resetImWebimCustomerList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.imWebimCustomerList = [];
            },
            resetDialog() {
                this.imWebimCustomerState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户
                      customerName: '', //客服名称
                      customerHeader: '', //客服头像
                      greeting: '', //问候语
                      companyName: '', //公司名称
                      companyDescription: '', //公司简介
                      multipleSeat: '', //默认单坐席0  可选多坐席1
                      aiCustomer: '', //0 人工客服 1 智能客服
                };
                this.getImWebimCustomerList();
            },
            closeDialog() {
                this.showDialog = false
                this.imWebimCustomer = {
                      id: '', //ID
                      userId: '', //用户
                      customerName: '', //客服名称
                      customerHeader: '', //客服头像
                      greeting: '', //问候语
                      companyName: '', //公司名称
                      companyDescription: '', //公司简介
                      multipleSeat: 0, //默认单坐席0  可选多坐席1
                      aiCustomer: 0, //0 人工客服 1 智能客服
                      createTime: '', //
                };
            },
            submitForm() {
                if (this.imWebimCustomerState == 'add') {
                    this.$refs.imWebimCustomerForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/im/webimcustomer/add`,{ ...this.imWebimCustomer }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetImWebimCustomerList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.imWebimCustomerState == 'edit') {
                    this.$refs.imWebimCustomerForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/im/webimcustomer/edit`,{ ...this.imWebimCustomer }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetImWebimCustomerList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addImWebimCustomer() {
                this.showDialog = true;
                this.imWebimCustomerState = 'add';
            },
            checkImWebimCustomer(imWebimCustomerId) {
                console.log(imWebimCustomerId);
                this.currentImWebimCustomerId = imWebimCustomerId;

                this.getImWebimCustomerById();
                this.showDialog = true;
                this.imWebimCustomerState = 'check';
            },
            editImWebimCustomer(imWebimCustomerId) {
                console.log('imWebimCustomer', imWebimCustomerId);
                if (imWebimCustomerId) {
                    this.currentImWebimCustomerId = imWebimCustomerId;
                    this.getImWebimCustomerById();
                } else {
                    this.imWebimCustomer = { ...this.imWebimCustomer, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.imWebimCustomerState = 'edit';
            },
            deleteImWebimCustomer(imWebimCustomerId) {
                let ids = '';
                if (imWebimCustomerId) {
                    ids = imWebimCustomerId;
                } else {
                    ids = this.multipleSelection.map((imWebimCustomer) => imWebimCustomer.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/im/webimcustomer/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetImWebimCustomerList();
                                this.getImWebimCustomerList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshImWebimCustomerList() {
                this.resetImWebimCustomerList();
                this.getImWebimCustomerList();
            },
            getImWebimCustomerList(query = {}) {
                this.loading = true;
                get(`/im/webimcustomer/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.imWebimCustomerList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getImWebimCustomerById() {
                get(`/im/webimcustomer/get`,{ id: this.currentImWebimCustomerId }).then((res) =>{
                    if(res.success){
                      this.imWebimCustomer = { ...this.imWebimCustomer, ...res.imWebimCustomer };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportImWebimCustomerList() {
                //this.btnLoading = true;
                exprotExcel(`/im/webimcustomer/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/im/webimcustomer/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/im/webimcustomer/importData`,formData);
              this.refreshImWebimCustomerList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getImWebimCustomerList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getImWebimCustomerList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 177px;
    height: 177px;
    line-height: 177px;
    text-align: center;
}
.avatar {
    width: 177px;
    height: 177px;
    display: block;
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 177px;
    height: 177px;
}
</style>